import React from 'react';
import renderer from 'modules/renderer';
import Survey from 'components/shared/survey';
import CommonProviders from 'components/common-providers';

const show = () => {
  renderer(
    (
      <CommonProviders>
        <Survey survey={CityGrows.Server.surveyData} />
      </CommonProviders>
    ), document.getElementById('survey'),
  );
};

export default {
  show,
};
